import { computed, ref } from "vue";

export type TableColumn = {
	value: string;
	title: string;
	enabled: boolean;
};

export const useTableColumns = (columns: TableColumn[]) => {
	const columnsRef = ref(columns);

	const isColumnEnabled = (value: string) => {
		const column = columnsRef.value.find(col => col.value === value);
		return column && column.enabled;
	};

	const toggleColumn = (index: number) => {
		columnsRef.value[index].enabled = !columnsRef.value[index].enabled;
	};

	const columnsBitmask = computed(() =>
		columnsRef.value.map(col => col.enabled)
	);

	return {
		columns: columnsRef,
		isColumnEnabled,
		toggleColumn,
		columnsBitmask,
	};
};
